export { CollectiblesView } from './CollectiblesView'
